function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 385 170"
}, props), React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("path", {
  d: "M0 15C0 9.477 4.477 5 10 5h404c5.523 0 10 4.477 10 10v130c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10V15z",
  fill: "#fff"
})), React.createElement("rect", {
  width: "325",
  height: "20",
  rx: "10",
  transform: "matrix(1 0 0 -1 30 105)",
  fill: "#E52F00"
}), React.createElement("rect", {
  width: "269.286",
  height: "20",
  rx: "10",
  transform: "matrix(1 0 0 -1 30 105)",
  fill: "#E52F00"
}), React.createElement("rect", {
  width: "130",
  height: "15",
  rx: "2",
  transform: "matrix(1 0 0 -1 30 70)",
  fill: "#F2F2F2"
}), React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: "-10",
  y: "0",
  width: "444",
  height: "170",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: "5"
}), React.createElement("feGaussianBlur", {
  stdDeviation: "5"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));